import { REQUEST_TYPES } from '.';

export const recaptchaVerifyRequest = token => ({
  type: '[API] Verify reCAPTCHA',
  url: '/generateToken',
  APIMethod: REQUEST_TYPES.POST,
  body: { applicationId: 'TxT', token },
});
